<ion-split-pane
  contentId="appContent"
  when="(min-width: 992px)"
  [ngClass]="{ marginIonPane: showLoginForgotPasswordFooter(previousUrl) }"
>
  <ion-menu
    side="start"
    menuId="appMenu"
    contentId="appContent"
    type="overlay"
  >
    <ion-header>
      <ion-toolbar>
        <ion-title> </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="navigation-container">
        @if (smallScreen) {
          <ion-menu-button
            menu="appMenu"
            autoHide="false"
            slot="start"
            id="appmenuButton"
            (click)="(closeMenu)"
          ></ion-menu-button>
        }
        <div class="logo" slot="end">
          <img src="../../../assets/imgs/logo_transparent_bigger.png" />
        </div>
        <div class="navigation-box">
          <ion-list lines="none">
            <ion-menu-toggle autoHide="false">
              @for (pages of navigation; track $index) {
                @if (showPage(pages.url)) {
                  <ion-item
                    button
                    [routerLink]="null"
                    [class.activeLink]="previousUrl === pages.url"
                    [attr.id]="pages.id"
                    (click)="routeToUrl(pages.url, $event)"
                  >
                    <ion-icon [name]="pages.icon" slot="start"></ion-icon>
                    {{ pages.title | translate }}
                    @if (pages.url === '/invitations' && parserService.invitations.length > 0) {
                      <ion-badge
                        slot="end"
                        class="badge-background"
                      >
                        {{ parserService.invitations.length }}
                      </ion-badge>
                    }
                    @if (pages.url === '/feedback-overview' && parserService.newMessages > 0) {
                      <ion-badge
                        slot="end"
                        class="badge-background"
                      >
                        {{ parserService.newMessages }}
                      </ion-badge>
                    }
                  </ion-item>
                }
              }
            </ion-menu-toggle>
          </ion-list>
        </div>

        <div class="navigation-box navigation-spacer"></div>

        @if (showAppStoreLinks) {
          <ion-grid class="navigation-box store-download">
            <ion-row class="ion-justify-content-center">
              <ion-col size="6">
                <a [href]="appstore_url" target="_blank" rel="noopener noreferrer">
                  @switch (language) {
                    @case ('ca') {
                      <ion-img src="../assets/imgs/appstore/download-appstore-ca-es.svg" />
                    }
                    @case ('de') {
                      <ion-img src="../assets/imgs/appstore/download-appstore-de.svg" />
                    }
                    @case ('es') {
                      <ion-img src="../assets/imgs/appstore/download-appstore-ca-es.svg" />
                    }
                    @case ('fr') {
                      <ion-img src="../assets/imgs/appstore/download-appstore-fr.svg" />
                    }
                    @case ('ro') {
                      <ion-img src="../assets/imgs/appstore/download-appstore-ro.svg" />
                    }
                    @default {
                      <ion-img src="../assets/imgs/appstore/download-appstore.svg" />
                    }
                  }
                </a>
              </ion-col>
              <ion-col size="6">
                <a [href]="playstore_url" target="_blank" rel="noopener noreferrer">
                  @switch (language) {
                    @case ('ca') {
                      <ion-img src="../assets/imgs/playstore/download-playstore-ca.png" />
                    }
                    @case ('de') {
                      <ion-img src="../assets/imgs/playstore/download-playstore-de.png" />
                    }
                    @case ('es') {
                      <ion-img src="../assets/imgs/playstore/download-playstore-es.png" />
                    }
                    @case ('fr') {
                      <ion-img src="../assets/imgs/playstore/download-playstore-fr.png" />
                    }
                    @case ('ro') {
                      <ion-img src="../assets/imgs/playstore/download-playstore-ro.png" />
                    }
                    @default {
                      <ion-img src="../assets/imgs/playstore/download-playstore.png" />
                    }
                  }
                </a>
              </ion-col>
            </ion-row>
          </ion-grid>
        }

        <div class="navigation-box">
          <ion-item class="technicalItem">
            <ion-icon name="help-circle-outline"></ion-icon>
            <a
              id="supportButton"
              (click)="openEmailSupport()"
              class="sidebarlink"
            >
              {{ "SUPPORT.TECHNICAL_SUPPORT" | translate }}
            </a>
          </ion-item>
        </div>

        <ion-footer class="imprintfooter">
          <ion-menu-toggle autoHide="false">
            <a
              class="sidebarlink"
              id="navImprint"
              (click)="routeToUrl('imprint', $event)"
            >
              {{ "PAGES.IMPRINT" | translate }}
            </a>
            |
            <a
              class="sidebarlink"
              id="navPrivacy"
              (click)="routeToUrl('privacy', $event)"
            >
              {{ "PAGES.PRIVACY" | translate }}
            </a>
            |
            <a
              class="sidebarlink"
              id="navSecurity"
              (click)="routeToUrl('security', $event)"
            >
              {{ "PAGES.SECURITY_DECLARATION" | translate }}
            </a>
            |
            <a
              class="sidebarlink"
              id="navTermsAndConditions"
              (click)="routeToUrl('terms-and-conditions', $event)"
            >
              {{ "PAGES.TERMS_AND_CONDITIONS" | translate }}
            </a>
          </ion-menu-toggle>
        </ion-footer>
      </div>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="appContent"></ion-router-outlet>
</ion-split-pane>
@if (showLoginForgotPasswordFooter(previousUrl)) {
  <footer>
    <a
      class="sidebarlink"
      id="navImprint"
      (click)="routeToUrl('app-imprint', $event)"
    >
      {{ "PAGES.IMPRINT" | translate }}
    </a>
    |
    <a
      class="sidebarlink"
      id="navPrivacy"
      (click)="routeToUrl('app-privacy', $event)"
    >
      {{ "PAGES.PRIVACY" | translate }}
    </a>
    |
    <a
      class="sidebarlink"
      id="navTermsAndConditions"
      (click)="routeToUrl('app-terms-and-conditions', $event)"
    >
      {{ "PAGES.TERMS_AND_CONDITIONS" | translate }}
    </a>
  </footer>
}
